module.exports = __webpack_public_path__ + "images/blog-banner-users-light.png";